// player images
import yao_ming from '../../../../../../assets/images/yao_ming.png';
import adrien from '../../../../../../assets/images/adrien.png';
import matteo from '../../../../../../assets/images/matteo.png';
import camille from '../../../../../../assets/images/camille.png';
// trophies
import goldTrophy from '../../../../../../assets/svgs/gold_trophy.svg';
import silverTrophy from '../../../../../../assets/svgs/silver_trophy.svg';
import bronzeTrophy from '../../../../../../assets/svgs/bronze_trophy.svg';

export const gameHeaders = [
  { title: "Rank" },
  { title: "" },         // Placeholder for Player Image
  { title: "Username" },
  { title: "Points" }
];

// Function to get the correct trophy based on rank
export const getTrophyIcon = (rank) => {
  if (rank === 1) return goldTrophy;
  if (rank === 2) return silverTrophy;
  if (rank === 3) return bronzeTrophy;
  return null;
};

export const playersData = [
  {
    id: 1,
    rank: 1,
    userNickName: 'Zain',
    tokenPoints: 200,
    userProfileImageUrl: yao_ming,
    // isUser: true,
  },
  {
    id: 2,
    rank: 2,
    userNickName: 'Andrien',
    tokenPoints: 200,
    userProfileImageUrl: adrien,
  },
  {
    id: 3,
    rank: 3,
    userNickName: 'Matteo',
    tokenPoints: 200,
    userProfileImageUrl: matteo,
  },
  // Additional players without trophies
  {
    id: 4,
    rank: 4,
    userNickName: 'Camille',
    tokenPoints: 200,
    // userProfileImageUrl: camille,
  },
  {
    id: 5,
    rank: 4,
    userNickName: 'Camille',
    tokenPoints: 200,
    userProfileImageUrl: camille,
    isUser: true,
  },
  {
    id: 6,
    rank: 5,
    userNickName: 'Camille',
    tokenPoints: 200,
    userProfileImageUrl: camille,
  },
  {
    id: 7,
    rank: 6,
    userNickName: 'Camille',
    tokenPoints: 200,
    userProfileImageUrl: camille,
  },
  {
    id: 8,
    rank: 7,
    userNickName: 'Camille',
    tokenPoints: 0,
    userProfileImageUrl: camille,
  },
];
